<template>
    <div class="bg-white px-3 pt-3 rounded-top">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="fs-12">Claim Your Offer Now!</span>
            <div class="text-white rounded-pill timer py-1 px-2">
                <img src="../../assets/icons/timer.svg" alt=""> <vue-countdown :time="2700000"
                    v-slot="{ minutes, seconds }">
                    {{ minutes }}:{{ seconds }}
                </vue-countdown>
            </div>
        </div>
        <form class="needs-validation" @submit.prevent="check" novalidate>
            <div v-if="stepNumber == 1">
                <div class="mb-2">
                    <input type="text" class="form-control form-control-lg " :class="{ 'is-valid': form.firstName }"
                        placeholder="First name" aria-label="First name" v-model="form.firstName" id="firstName"
                        required>
                </div>
                <div class="mb-2">
                    <input type="text" class="form-control form-control-lg" placeholder="Last name"
                        aria-label="Last name" v-model="form.lastName" id="lastName" required>
                </div>
            </div>
            <div v-if="stepNumber == 2">
                <div class="mb-2">
                    <input type="Email" class="form-control form-control-lg" placeholder="Email" aria-label="Email"
                        v-model="form.email" id="email" required>

                </div>
                <div class="mb-2">
                    <input type="tel" class="form-control form-control-lg" placeholder="Phone Number"
                        aria-label="Phone Number" maxlength="10" minlength="10" pattern="^\d{10}$" v-model="form.phone"
                        id="phoneNumber" required>

                </div>
            </div>
            <div v-if="stepNumber == 3">
                <div class="mb-2">
                    <span>Do you have fixed dates?</span>
                </div>
                <div class="mb-2">
                    <input type="radio" name="role" value="true" id="one" v-model="enableDatesInput">
                    <label class="role px-2" for="one">Yes</label>
                    <input type="radio" name="role" value=false id="two" v-model="enableDatesInput">
                    <label class="role px-2" for="two">No</label>
                </div>
                <div class="mb-2 d-flex" v-if="getDatesInputState">
                    <DatePicker class="pe-2" placeholder="Arrival" :enable-time-picker="false" v-model="arrivalD"
                        :state="arrivalD" required>
                        <template #input-icon>
                            <img class="input-slot-image" src="../../assets/icons/calendar_month.svg" />
                        </template>
                    </DatePicker>
                    <DatePicker placeholder="Departure" :enable-time-picker="false" v-model="departureD"
                        :state="departureD" required>
                        <template #input-icon>
                            <img class="input-slot-image" src="../../assets/icons/calendar_month.svg" />
                        </template>
                    </DatePicker>
                </div>
                <div class="col py-4 mb-3" v-else></div>
            </div>
            <div v-if="stepNumber == 4">
                <div class="mb-2 d-flex form-control py-lg-5 ps-1 border-0 px-0 text-center justify-content-center align-items-center"
                    data-bs-toggle="modal" data-bs-target="#termsModal">
                    <input class="form-check-input" :class="{ 'is-valid': form.termsAgreement }" type="checkbox"
                        id="termsAgreement" v-model="form.termsAgreement" required>
                    <label class="ps-lg-3 pt-1 fs-6 ps-2" for="flexCheckDefault">
                        <div type="button" class="p-0 m-0">
                            I agree to the <span class="tnc-lbl">Terms & Conditions.</span>
                        </div>
                    </label>
                </div>
                <TheTermsModal />
            </div>
            <div class="d-flex pb-2">
                <div class="col-2 d-flex align-items-center" v-if="stepNumber > 1" @click="stepBack()">
                    <div class="btn"><img src="../../assets/icons/left_arrow.svg" alt=""></div>
                </div>
                <div class="col">
                    <button type="submit"
                        class="col-12 h-100 btn btn-lg btn--submit d-flex justify-content-between align-items-center"
                        :style="branding.buttons"><span>
                            {{ btnLbl }}</span> <img src="../../assets/icons/arrow_right.svg" alt=""> </button>
                </div>
            </div>
        </form>
    </div>
    <div class="col rounded-1">
        <div class="row m-0">
            <div class="col pb-1 progress-bar--inactive" :class="{ 'progress-bar--active': this.stepNumber === 1 }">
            </div>
            <div class="col pb-1 progress-bar--inactive" :class="{ 'progress-bar--active': this.stepNumber === 2 }">
            </div>
            <div class="col pb-1 progress-bar--inactive" :class="{ 'progress-bar--active': this.stepNumber === 3 }">
            </div>
            <div class="col pb-1 progress-bar--inactive" :class="{ 'progress-bar--active': this.stepNumber === 4 }">
            </div>
        </div>
    </div>
    <div class="col fs-12 text-white pt-2">
        Step {{ stepNumber }}/4: {{ stepLabel }}
    </div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref } from 'vue';
import TheTermsModal from './TheTermsModal.vue';
import axios from "axios";
import Swal from 'sweetalert2'
import { useStore } from '@/store/landing';

export default {
    setup() {
        return {
            websiteStore: useStore()
        }
    },
    data() {
        return {
            date: ref({
                day: new Date().getDay(),
                month: new Date().getMonth(),
                year: new Date().getFullYear()
            }),
            stepNumber: 1,
            stepLabel: 'Personal Information',
            departureD: false,
            arrivalD: false,
            disableDatesForm: false,
            departureD: null,
            arrivalD: null,
            enableDatesInput: 'true',
            btnLabel: 'I want this deal!',
            varWebhookId: '',
            form: {
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                arrivalDate: null,
                departureDate: null,
                destination: "",
                campaignName: "",
                adID: "",
                termsAgreement: "",
                leadTypeID: 48
            }
        }
    },
    props: {
        destination: String
    },
    components: {
        VueCountdown,
        DatePicker,
        TheTermsModal
    },
    methods: {
        async check({ target }) {
            if (target.checkValidity()) {
                this.stepNumber = this.stepNumber + 1
                if (this.stepNumber > 4) {
                    this.loadingMessage();
                    let webhookform = {
                        webhookID: this.varWebhookId,
                        firstName: this.form.firstName,
                        lastName: this.form.lastName,
                        email: this.form.email,
                        phone: this.form.phone,
                        leadTypeID: 48,
                        leadSourceChannelID: this.form.leadSourceChannelID,
                        leadSourceID: this.form.leadSourceID,
                        campaignName: this.form.campaignName,
                        destination: this.destination,
                        arrivalDate: this.formatDate(this.arrivalD),
                        departureDate: this.formatDate(this.departureD)
                    };
                    await axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                        .post('https://hooks.zapier.com/hooks/catch/11321198/2bekjdf/', webhookform)
                        .then(function (response) {
                            console.log("Correct " + response);
                        }).catch(function (error) {
                            console.log("Error: " + error)

                        });
                    this.successMessage()
                    this.$router.push({
                        path: '/confirmation',
                        query: {
                            destination: this.destination,
                            utm_campaign: this.$route.query.utm_campaign
                        }
                    })
                } else {
                    this.btnLbl = this.stepNumber
                }

            }
            else {
                target.classList.add('was-validated')
                this.form.arrivalDate = false
                this.form.departureDate = false
                this.showValidationToast()

            }
        },
        stepBack() {
            if (this.stepNumber <= 4) {
                this.stepNumber = this.stepNumber - 1
                this.btnLbl = this.stepNumber
            }
        },
        showValidationToast() {
            const toastLiveExample = document.getElementById('liveToast')
            //eslint-disable-next-line
            const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample)
            toastBootstrap.show()
        },
        loadingMessage() {
            this.loading = Swal.mixin({
                customClass: {
                    loader: 'spinner',
                }
            })
            return this.loading.fire({
                text: "Submitting",
                showConfirmButton: false,
                iconColor: "#0c9491",
                backdrop: `rgba(0,101,129,0.7)`,
                width: 160,
                timerProgressBar: true,
                // timer: 3000,
                didOpen: () => {
                    this.loading.showLoading();
                },
            });
        },
        errorMessage() {
            return Swal.fire({
                icon: "warning",
                title: "Oops",
                text: "An unexpected error ocurred, please try again.",
                iconColor: "#ffd700",
                showConfirmButton: false,
                timer: 5000,
                backdrop: `rgba(0,101,129,0.7)`,
            });
        },
        successMessage() {
            return Swal.fire({
                icon: "success",
                title: "Thanks, all ready set.",
                text: "An agent will be in touch with you soon.",
                color: "#0C9491",
                showConfirmButton: false,
                timer: 5000,
                iconColor: "#0C9491",
                backdrop: `rgba(0,101,129,0.7)`,
            });
        },
        goToConfirmation() {
            this.$router.push({
                name: 'confirmation',
                params: {
                    slug: this.$route.params.slug,
                    type: this.$route.params.type
                },
                query: this.$route.query // Esto mantiene todos los query parameters
            })
        },
        formatDate(date) {
            if (!date) return null;
            const d = new Date(date);
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            const year = d.getFullYear();
            return `${month}/${day}/${year}`;
        },
    },
    computed: {
        getDatesInputState() {
            return this.enableDatesInput === 'true' ? true : false
        },
        btnLbl: {
            get() {
                return this.btnLabel
            },
            set(stepNumber) {
                switch (stepNumber) {
                    case 1:
                        this.stepLabel = 'Personal Information'
                        this.btnLabel = 'I want this deal!'
                        break;
                    case 2:
                        this.stepLabel = 'Contact Information'
                        this.btnLabel = 'Almost got it!'
                        break;
                    case 3:
                        this.stepLabel = 'Travel Date'
                        this.btnLabel = 'Just one step away!'
                        break;
                    case 4:
                        this.stepLabel = 'Agreement'
                        this.btnLabel = 'Submit'
                        break;
                    default:
                        break;
                }
            }
        },
        branding() {
            return this.websiteStore.getCampaignBranding(this.$route.query.utm_campaign);
        }
    },
    mounted() {
        const query = this.$route.query;
        this.form.leadSourceChannelID = query.utm_medium || '';
        this.form.leadSourceID = query.utm_source || '';
        this.form.campaignName = query.utm_campaign || '';
        this.varWebhookId = query.utm_source == 'google' ? '458e97aa-baf3-cf1c-efde-253e5a4bf1d7' : 'a9157b0c-d153-a5ea-4c67-ef134055e473';
    }

}
</script>


<style scoped>
.timer {
    font-size: 12px !important;
    color: #ffff;
    background-color: #d50758;
    font-family: "Poppins", sans-serif;
    font-size: 12px;
}

.fs-12 {
    font-size: 12px;
}

.btn--submit {
    background: rgb(12, 148, 145);
    background: linear-gradient(91deg, #F9AE06 0%, #FF1F1F 100%);
    color: #fff;
}

.btn--submit:hover {
    background: rgb(12, 148, 145);
    background: linear-gradient(91deg, #F9AE06 0%, #FF1F1F 100%);
    color: #fff;
}

.progress-bar--active {
    background-color: #0C9491 !important;
}

.progress-bar--inactive {
    background-color: #c8c8c8;
}

input[type='radio'] {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    outline: none;
    border: 2px solid #d7d7d7;
}

input[type='radio']:before {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    margin: 2px 2px;
    border-radius: 50%;
}

input[type="radio"]:checked:before {
    background: #0C9491;

}

input[type="radio"]:checked {
    border-color: #0C9491;
    border: 2px solid #d7d7d7;
}
</style>